/**
 * Created by 1 on 2017/8/28.
 */
'use strict';
define([
    './PlotComponent',
    './PlotComponent3D',
    './PlotSchema',
    './PlotTypes',
    './plotSync/plotSync/PlotSyncComponent',
    './plotSync3D/plotSync3D/PlotSyncComponent3D',
    './plotSync/collaborativePlot/CollaborativePlotComponent',
    './plotSync3D/collaborativePlot3D/CollaborativePlotComponent3D'
], function (PlotComponent,
             PlotComponent3D,
             PlotSchema,
             PlotTypes,
             PlotSyncComponent,
             PlotSyncComponent3D,
             CollaborativePlotComponent,
             CollaborativePlotComponent3D) {
    /**
     * @namespace
     * @memberOf G
     * @description 标绘包
     */
    let plot = {
        PlotComponent: PlotComponent,
        PlotComponent3D: PlotComponent3D,
        PlotSchema: PlotSchema,
        PlotSyncComponent: PlotSyncComponent,
        PlotSyncComponent3D: PlotSyncComponent3D,
        CollaborativePlotComponent: CollaborativePlotComponent,
        CollaborativePlotComponent3D: CollaborativePlotComponent3D
    }
    /**
     * 定义标绘类型
     */
    Object.defineProperty(plot, 'TYPES', {
        value: PlotTypes.TYPES_KEYS,
        configurable: false,
        writable: false
    });
    
    return plot;
    
});